import {useCallback, useEffect, useState} from "react";

import {getUserOrganizations} from "../api/userOrganization";
import {Organization} from "../../../types/Organization";
import {UserOrganization} from "../model/types";

export const useUserOrganizations = (userToken: string) => {
  const [users, setUsers] = useState<UserOrganization[]>([]);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchUsers = useCallback(async () => {
    if (!userToken) {
      return;
    }

    setIsLoading(true);
    try {
      const {
        users: tempUsers,
        organizations: tempOrganizations
      } = await getUserOrganizations({token: userToken}) || {users: [], organizations: []};
      setUsers(tempUsers);
      setOrganizations(tempOrganizations);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [userToken]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return {
    users,
    organizations,
    isLoading,
    fetchUsers,
  };
};
